import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { CustomTextField } from 'components';
import { AccessLevelSelect, AccessLevelValue } from 'components/ui/AccessLevelSelect';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { CapTableFormProps, FormValueCapTable } from './CapTableForm.props';
import { classes, StyledGrid } from './CapTableForm.styles';


const constraints = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

const CapTableForm = ({
  defaultFormState: { values, errors, dbErrors },
  onFormChange,
  accessLevelDisabled,
}: CapTableFormProps) => {
  const { formValidated, validateForm } = useFormValidation(constraints);
  const [formValues, setFormValues] = useState<FormValueCapTable>(values);

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  useEffect(() => {
    onFormChange(formValidated);
  }, [onFormChange, formValidated]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleAccessLevelChange = useCallback((value: AccessLevelValue) => {
    setFormValues(prev => ({
      ...prev,
      access_level: value,
    }));
  }, []);

  return (
    <StyledGrid container>
      <Grid size={12}>
        <CustomTextField
          required
          fullWidth
          id="name"
          name="name"
          type="text"
          label="Name"
          className={classes.margin}
          value={formValues.name as string}
          onChange={handleChange}
          formErrors={errors}
          dbErrors={dbErrors}
        />
      </Grid>
      {formValues.access_level !== undefined && (
        <Grid size={12}>
          <Typography gutterBottom sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
            Access Options
          </Typography>
          <AccessLevelSelect
            value={formValues.access_level}
            onChange={handleAccessLevelChange}
            disabled={accessLevelDisabled}
            fullWidth
          />
        </Grid>
      )}
    </StyledGrid>
  );
};

export default CapTableForm;
